import React from "react";
import { FiSearch } from "react-icons/fi";

export default function SearchField({ onChange, onClick, value, mainclassName }) {
    
  return (
    <div
      style={{
        marginTop: "-10px",
        display: "flex",
        justifyContent: "end",
        marginBottom: "10px",
        marginLeft: "-5px",
      }}
      className={mainclassName}
    >
      <div className="actsearch_box1">
        <FiSearch className="boxicon" />
        <input
          value={value}
          placeholder="Search Here..."
          className="ms-2"
          onChange={(e) => onChange(e)}
          onClick={onClick}
          readOnly
        />
      </div>
    </div>
  );
}
